import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CashFlowPageUI from './CashFlowPageUI.js'

class CashFlowPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      cashFlowList: null,
      createMode: false,
      updateMode: false,
      selectedCashFlow: null,
      cashFlowDownloadRequested: false,
      cashFlowUploadMode: false
    }
  }

  render() {
    return (
      <CashFlowPageUI
        context={this.props.context}
        account={this.state.account}
        cashFlowList={this.state.cashFlowList}
        onRefreshClick={this.onRefreshClick}
        createMode={this.state.createMode}
        onCreateClick={() => {this.setState({'createMode': true})}}
        onCancelClick={() => {this.setState({'createMode': false, 'updateMode': false})}}
        onUpdateClick={this.onUpdateClick}
        updateMode={this.state.updateMode}
        selectedCashFlow={this.state.selectedCashFlow}
        //
        onDownloadCashFlowTemplate={this.onDownloadCashFlowTemplate}
        cashFlowDownloadRequested={this.state.cashFlowDownloadRequested}
        //
        cashFlowUploadMode={this.state.cashFlowUploadMode}
        onCashFlowUploadClick={() => { this.setState({ cashFlowUploadMode: true }) }}
        onCashFlowUploadCancel={() => { this.setState({ cashFlowUploadMode: false }) }}
        onCashFlowUpload={this.onCashFlowUpload}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getCashFlows(context)
  }

  getCashFlows(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cashFlows`,
      cacheKey: CacheKeys.CashFlows(this.props.match.params.accountId),
      callback: this.getCashFlowsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCashFlowsCallback = (response) => {
    this.setState({cashFlowList : response.cashFlowList})
  }

  onUpdateClick = (event) => {
    let year = event.currentTarget.getAttribute("data-year")
    let month = event.currentTarget.getAttribute("data-month")
    let selectedCashFlow = this.state.cashFlowList.filter(cf => cf.year == year && cf.month == month)[0]
    this.setState({'updateMode': true, 'selectedCashFlow': selectedCashFlow})
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({account : response.account})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.CashFlows(this.props.match.params.accountId))
    this.setState({cashFlowList: null}, () => {
      this.getCashFlows(context)
    })
  }

  onDownloadCashFlowTemplate = () => {
    let context = this.props.context
    this.setState({ cashFlowDownloadRequested: true })
    RestApiUtils.get(context, `/api/pub/contents/account_file_upload_templates/cashflow.csv`, 
      this.onDownloadCashFlowTemplateCallback, null, null)
  }

  onDownloadCashFlowTemplateCallback = (response) => {
    this.setState({ cashFlowDownloadRequested: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.publicURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onCashFlowUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      cashFlowUploadSubmitted: true,
      cashFlowUploadSuccessMsg: null,
      cashFlowUploadErrorList: [],
    })
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/cashFlows/validation`,
      this.onCashFlowUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onCashFlowUploadCallback = (response) => {
    this.setState({ cashFlowUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      cashFlowUploadSuccessMsg: response.success,
      cashFlowUploadErrorList: errorList,
    })

    this.onRefreshClick()

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          cashFlowUploadSuccessMsg: null
        })
      }, 2000)
    }
  }

}

export default withRouter(CashFlowPageSF)
